import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

/**
 * @typedef GetMissionsByCityQueryVars
 * @property {number} cityId Mandatory city id
 * @property {number} clientId Filter by client
 * @property {string} statusAndAbove Filter by status
 * @property {string} filter Filter by search text
 * @property {string} statusAndBelow Filter by status
 * @property {string} timeOfDay Filter by time of day
 * @property {number} campaignId Filter by campaign
 * @property {string} startDate Filter by start date
 * @property {string} endDate Filter by end date
 * @property {MissionTypeEnum[]} types Filter by type of mission
 *
 * Get missions within a city
 * @param {GetMissionsByCityQueryVars} queryVars
 */
export const getMissionsForCity = function(queryVars) {
  const query = `query (
    $cityId:ID!
    $clientId:ID
    $campaignId:ID
    $startDate:String
    $endDate:String
    $timeOfDay: MissionTimeOfDayEnum
    $filter:String
    $types: [MissionTypeEnum!]
    $statuses: [MissionStatusEnum]
  ) {
    city(id: $cityId){
      id
      name
      country { id }
      latitude
      longitude
      lunchCheckInTime
      afternoonCheckInTime
      timezone
      missions(
        clientId: $clientId
        campaignId: $campaignId
        startDate: $startDate
        endDate: $endDate
        timeOfDay: $timeOfDay
        filter: $filter
        types: $types
        statuses: $statuses
      ){
        edges {
          node {
            id
            dateTime
            status
            type
            cityPlan {
              campaign {
                client {
                  name
                  id
                }
              }
              city {
                afternoonCheckInTime
                lunchCheckInTime
              }
            }
            location {
              name
              latitude
              longitude
            }
            boundary {
              latitude
              longitude
            }
            boundaryColour
            user {
              firstName
              lastName
              id
            }
            flyerCode
            checkInTime
            checkInLocation {
              latitude
              longitude
            }
            checkoutTime
            checkoutStepsWalked
            checkInSelfie
            checkInFlyerCodeImage
            checkoutLocation {
              latitude
              longitude
            }
          }
        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}



// WEBPACK FOOTER //
// ./src/Components/LiveMap/graphql.js